import { HRMonthly_Appraisal } from "../../Server/ApiV2";

export const onGetHRMonthly_Appraisal = async (postData) => {
  try {
    const response = await HRMonthly_Appraisal(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
